import { render, staticRenderFns } from "./ProductLayout.vue?vue&type=template&id=672be7d3&"
import script from "./ProductLayout.vue?vue&type=script&lang=js&"
export * from "./ProductLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports